window.SubscriptionFunnel.StepNameAndGender = {
  initialize() {
    let dogName = quizData.dogName;

    document.querySelectorAll("[data-dog-name]").forEach((el) => {
      el.textContent = dogName || "your pup";
    });

    document.querySelectorAll("[data-dog-name-uppercase]").forEach((el) => {
      el.textContent = dogName.toUpperCase() || "your pup";
    });
  },

  validateDogNameGender() {
    const dogName = document.getElementById("dog-name").value;
    if (!dogName) {
      document
        .getElementById("dog-name")
        .classList.add("text-input-component-input--error");
      document
        .querySelector(
          `div.text-input-component:has(#dog-name) div .form-input-text-error-message`
        )
        .classList.remove("display-none");
      return false;
    }

    quizData.dogName =
      SubscriptionFunnel.FunnelUtilities.capitalizeDogName(dogName);
    SubscriptionFunnel.FunnelNavigation.nextStep();
  },
};
